import { useMemo } from 'react';
import count from 'transmute/count';
import I18n from 'I18n';
import MessageHistoryCore from 'conversations-message-history/web/message-history/components/MessageHistoryCore';
import ThemeConfigProvider from 'conversations-visitor-message-history/theming/providers/ThemeConfigProvider';
import { MessageHistoryConfig } from '../constants/MessageHistoryConfig';
// @ts-expect-error - No type definitions available
import ConnectedThreadHistoryFetcher from '../containers/ConnectedThreadHistoryFetcher';
import { buildMessageHistoryTheme } from 'conversations-visitor-message-history/utils/buildMessageHistoryTheme';
// @ts-expect-error - No type definitions available
import ConnectedNewThreadPrompt from '../../thread-view/containers/ConnectedNewThreadPrompt';
import { AriaLiveContextProvider } from 'visitor-ui-component-library/utils/aria-live/AriaLiveContext';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MessageHistoryWrapper = styled.div.withConfig({
  displayName: "ThreadHistory__MessageHistoryWrapper"
})(["z-index:0;padding-block-start:4px;padding-inline:16px;flex-shrink:0;@container chat-widget (max-width:900px){padding-inline:8px;}"]);
const ThreadHistory = ({
  coloring,
  fileAttachments,
  messagesList,
  portalId,
  senders,
  shouldRenderNewThreadPrompt,
  isChatTransferred
}) => {
  // The Initial Message Text Box Does not use the same rich text editor as the rest of the messages
  // this is a temporary fix to make sure that the new lines are rendered as <br> tags until we
  // can refactor the initialMessages text box to use the same editor as the rest of the messages
  const messages = useMemo(() => messagesList.map(message => {
    if (message.get('@type') === 'INITIAL_MESSAGE') {
      const richText = message.get('richText');
      return richText ? message.set('richText', richText.replace(/\n/g, '<br>')) : message;
    }
    return message;
  }).toList(), [messagesList]);
  return /*#__PURE__*/_jsx(ConnectedThreadHistoryFetcher, {
    messageCount: count(messagesList),
    shouldScrollToBottom: shouldRenderNewThreadPrompt,
    children: /*#__PURE__*/_jsx(ThemeConfigProvider, {
      themeConfig: buildMessageHistoryTheme({
        coloring
      }),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(AriaLiveContextProvider, {
          children: /*#__PURE__*/_jsx("section", {
            "aria-label": I18n.text('conversations-visitor-ui.visitorExperienceAriaLabels.messageHistory'),
            children: /*#__PURE__*/_jsx(MessageHistoryWrapper, {
              children: /*#__PURE__*/_jsx(MessageHistoryCore, {
                fileAttachments: fileAttachments,
                historyConfig: MessageHistoryConfig,
                messages: messages,
                portalId: portalId,
                senders: senders
              })
            })
          })
        }), shouldRenderNewThreadPrompt && /*#__PURE__*/_jsx(ConnectedNewThreadPrompt, {
          isChatTransferred: isChatTransferred
        })]
      })
    })
  });
};
ThreadHistory.displayName = 'ThreadHistory';
export default ThreadHistory;